import { includes, last, sortBy, values } from "lodash";
import { clearMessageFiles } from "../libs/fileHandler";
import { ChannelDeleteMessageResponse } from "../proto/ChannelDeleteMessage_pb";
import { ChatDeleteMessageResponse } from "../proto/ChatDeleteMessage_pb";
import { GroupDeleteMessageResponse } from "../proto/GroupDeleteMessage_pb";
import store from "../store";
import { editRoomMessage } from "../store/messages/actions";
import { editRoom } from "../store/rooms/actions";
import BaseHandler from "./BaseHandler";

export default class HandleMessagesDeleteMessageResponse extends BaseHandler<ChatDeleteMessageResponse | GroupDeleteMessageResponse | ChannelDeleteMessageResponse> {
  handle() {
    const messagesDeleteMessageResponse = this.response.toObject();
    store.dispatch(
      editRoomMessage({
        messageId: messagesDeleteMessageResponse.messageId,
        message: { deleted: true },
      })
    );
    if (store.getState().rooms.rooms[messagesDeleteMessageResponse.roomId]?.lastMessage?.messageId === messagesDeleteMessageResponse.messageId) {
      const roomMessages = values(store.getState().messages.messages).filter((m) => includes(store.getState().messages.roomMessages[messagesDeleteMessageResponse.roomId], m.messageId));
      const lastMessage = last(sortBy(roomMessages, "messageId").filter((m) => !m.deleted && m.messageId !== messagesDeleteMessageResponse.messageId));
      store.dispatch(
        editRoom({
          roomId: messagesDeleteMessageResponse.roomId,
          room: {
            lastMessage: lastMessage,
          },
        })
      );
    }
    clearMessageFiles(messagesDeleteMessageResponse.messageId);
  }
}
